import React from 'react';
export const StatsBar = () => {
  return <div className="border-y border-legal-700 bg-legal-800/50 py-4" data-id="element-250" data-mp="jxnff15hepjl">
      <div className="container mx-auto px-4" data-id="element-251" data-mp="1tbjift0ew4fe">
        <div className="grid grid-cols-5 gap-1 sm:gap-3 text-center divide-x divide-legal-700/60" data-id="element-252" data-mp="1t8niy08x17ou">
          <div className="flex flex-col items-center justify-center px-1" data-id="element-253" data-mp="1od88lia49tx6">
            <span className="text-base sm:text-xl font-bold text-white leading-none" data-id="element-254" data-mp="1jc2cdah8zoiw">
              +500
            </span>
            <span className="mt-1 text-[9px] sm:text-[10px] text-gold-500 font-semibold tracking-wide uppercase leading-tight" data-id="element-255" data-mp="1ef28n67vexuy">
              Abogados
            </span>
          </div>
          <div className="flex flex-col items-center justify-center px-1" data-id="element-256" data-mp="15it7nn48vr6p">
            <span className="text-base sm:text-xl font-bold text-white leading-none" data-id="element-257" data-mp="10n46jfcku28a">
              10
            </span>
            <span className="mt-1 text-[9px] sm:text-[10px] text-gold-500 font-semibold tracking-wide uppercase leading-tight" data-id="element-258" data-mp="vou72sjtkfgv">
              Módulos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center px-1" data-id="element-259" data-mp="3omj52r8l6hm5">
            <span className="text-base sm:text-xl font-bold text-white leading-none" data-id="element-260" data-mp="3tfvommyery81">
              5
            </span>
            <span className="mt-1 text-[9px] sm:text-[10px] text-gold-500 font-semibold tracking-wide uppercase leading-tight" data-id="element-261" data-mp="3erhedqynx7hg">
              Bonos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center px-1" data-id="element-262" data-mp="ba8vd3s781l5">
            <span className="text-base sm:text-xl font-bold text-white leading-none" data-id="element-263" data-mp="g8typc2qz1dt">
              2026
            </span>
            <span className="mt-1 text-[9px] sm:text-[10px] text-gold-500 font-semibold tracking-wide uppercase leading-tight" data-id="element-264" data-mp="1a8ahdeoldeu">
              Actualizado
            </span>
          </div>
          <div className="flex flex-col items-center justify-center px-1" data-id="element-265" data-mp="2m07g3g897aea">
            <span className="text-base sm:text-xl leading-none" data-id="element-266" data-mp="2r03nlpg5tjyl">🇦🇷</span>
            <span className="mt-1 text-[9px] sm:text-[10px] text-gold-500 font-semibold tracking-wide uppercase leading-tight" data-id="element-267" data-mp="2qxz80a8wewih">
              Todo el país
            </span>
          </div>
        </div>
      </div>
    </div>;
};